import { squareBlockCSS } from '@braskai/ui-kit';

import { ButtonBase, css, styled } from '@mui/material';

export const SButton = styled(ButtonBase)(
  ({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 44px;
    margin: 0 8px 26px;
    padding: 0 14px;
    border: 1px solid ${theme.palette.grey[200]};
    border-radius: 12px;
    background-color: ${theme.palette.common.white};
    font-family: ${theme.typography.fontFamily};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    white-space: nowrap;
    color: ${theme.palette.primary[500]};
    transition:
      background-color 0.16s ease,
      border-color 0.16s ease;

    &:hover {
      border-color: ${theme.palette.primary[300]};
      background-color: ${theme.palette.primary[100]};
    }

    &:focus-visible {
      outline: 2px solid ${theme.palette.primary[500]};
      outline-offset: 2px;
    }
  `,
);

export const SIcon = styled('span')(
  () => css`
    display: flex;
    flex-shrink: 0;
    ${squareBlockCSS(17)};

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  `,
);
